import { render, staticRenderFns } from "./ueber-uns.vue?vue&type=template&id=49ea2f44&scoped=true&"
var script = {}
import style0 from "./ueber-uns.vue?vue&type=style&index=0&id=49ea2f44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea2f44",
  null
  
)

export default component.exports